import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const ITConsulting = () => {
    useEffect(() => {
        // Force hide spinner immediately
        const spinner = document.getElementById('spinner');
        if (spinner) {
            spinner.classList.remove('show');
            spinner.style.display = 'none';
            spinner.style.opacity = '0';
            spinner.style.visibility = 'hidden';
        }
        if (window.WOW) {
            new window.WOW().init();
        }
    }, []);

    return (
        <>
            <WhatsAppFloat />
            <Navbar />

            {/* Page Header Start */}
            <div className="container-fluid page-header mb-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <h1 className="display-3 mb-4 animated slideInDown">IT Consulting</h1>
                    <nav aria-label="breadcrumb animated slideInDown">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="/">Home</a></li>
                            <li className="breadcrumb-item"><a href="/service">Pages</a></li>
                            <li className="breadcrumb-item active" aria-current="page">IT Consulting</li>
                        </ol>
                    </nav>
                </div>
            </div>
            {/* Page Header End */}

            {/* IT Consulting Start */}
            <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <h1 className="mb-4">Transform Your Business with Our Expert IT Consulting Services</h1>
                            <p>In a rapidly evolving technological landscape, staying ahead requires strategic guidance and expert insights. At WebBears, we offer comprehensive IT consulting services designed to help your business leverage technology for growth and efficiency.</p>
                            <ul>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>IT Strategy and Planning:</strong> Develop and implement IT strategies that align with your business goals.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Infrastructure Management:</strong> Optimize your IT infrastructure for improved performance and reliability.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Cloud Solutions:</strong> Leverage cloud technologies for scalability and flexibility.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>Cybersecurity:</strong> Protect your business with advanced cybersecurity measures.</li>
                                <li><i className="fa fa-check text-primary me-2"></i><strong>System Integration:</strong> Ensure seamless integration of your IT systems and applications.</li>
                            </ul>
                            <a className="btn btn-primary py-3 px-5" href="/contact">Contact Us</a>
                        </div>
                        <div className="col-lg-6">
                            <img className="img-fluid rounded wow zoomIn" data-wow-delay="0.5s" src="img/images/consulting.png" alt="IT Consulting" />
                        </div>
                    </div>
                </div>
            </div>
            {/* IT Consulting End */}

            <Footer />
        </>
    );
};

export default ITConsulting;
